/**
 * Shared constants for SendRfpDrawer components
 */

import type { SubmissionStatus } from "./api";

export type NotesTab = "rfp" | "coverages";

/** URL search param key for the eco RFP ID */
export const ECO_RFP_ID_PARAM = "ecoRfpId";

/** Drawer header title */
export const DRAWER_TITLE = "Send RFP to Carrier(s)";

/** Dialog type used to open the notes sub-drawer */
export const NOTES_DIALOG_TYPE = "notes";

/** Notes drawer dimensions */
export const NOTES_DRAWER_WIDTH = 43.75;
export const NOTES_DRAWER_WIDTH_UNIT = "em";

/** Submission status value indicating no submission in progress */
export const SUBMISSION_IDLE: SubmissionStatus = "idle";

/**
 * Mapping from API coverage type to display-friendly label
 */
export const COVERAGE_TYPE_TO_LABEL: Record<string, string> = {
  dental: "Dental",
  "dental-ppo": "Dental PPO",
  "dental-hmo": "DHMO",
  vision: "Vision",
  std: "STD",
  ltd: "LTD",
  basicLifeAdnd: "Basic Life/AD&D",
  voluntaryLifeAdnd: "Voluntary Life/AD&D",
  accident: "Accident",
  criticalIllness: "Critical Illness",
  hospitalIndemnity: "Hospital Indemnity",
  cancer: "Cancer",
  fmla: "FMLA",
  eap: "EAP",
  wholeLife: "Whole Life",
  individualDisabilityInsurance: "Individual Disability",
};

/**
 * US state abbreviations for address dropdowns
 */
export const US_STATES = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
] as const;

/**
 * BenAdmin system options for client details dropdown
 */
export const BEN_ADMIN_OPTIONS = [
  { label: "Employee Navigator", value: "employeeNavigator" },
  { label: "Ease", value: "ease" },
  { label: "BSwift", value: "bSwift" },
  { label: "ADP", value: "adp" },
  { label: "PlanSource", value: "planSource" },
  { label: "Paychex", value: "paychex" },
  { label: "TriNet", value: "triNet" },
  { label: "Rippling", value: "rippling" },
  { label: "Paylocity", value: "paylocity" },
  { label: "Selerix", value: "selerix" },
  { label: "Zenefits", value: "zenefits" },
  { label: "Workday", value: "workday" },
  { label: "Paycom", value: "paycom" },
  { label: "Other", value: "other" },
] as const;

/**
 * Technology credit type options
 */
export const TECH_CREDIT_OPTIONS = [
  { label: "Percentage", value: "percentage" },
  { label: "Dollar Amount", value: "dollarAmount" },
  { label: "PEPM", value: "pepm" },
  { label: "Carrier Standard", value: "carrierStandard" },
] as const;

/**
 * Yes/No options for boolean dropdowns
 */
export const YES_NO_OPTIONS = ["Yes", "No"] as const;
